<script lang="ts">
    import { isRenderable } from "@circleofa/acim-engine"
    import { isNavigableCategory, NavigableClass } from "@circleofa/acim-engine"
    import { slide } from "svelte/transition"
    import SubPageList from "./SubPageList.svelte"
    import { createEventDispatcher } from "svelte"
    import type { Writable } from "svelte/store"
    import { clickEnter } from "@utils/directives/accessibility"

    const dispatch = createEventDispatcher()

    export let focussedElement: HTMLElement
    export let uniqueIDOpenList: Writable<string[]>
    // export let title = true
    export let navigable: NavigableClass
    export let focussed: NavigableClass | null = null

    let link: HTMLElement
    let renderable = isRenderable(navigable.page)

    let open: boolean
    let alreadyOpen: boolean
    $: {
        const openAndNavigateConflict = isRenderable(navigable.page) && navigable.hasSubpages
        alreadyOpen = navigable.page.alreadyOpen || openAndNavigateConflict
        open = $uniqueIDOpenList.includes(navigable.uniqueID) || alreadyOpen
    }

    $: if (link && focussed == navigable && focussedElement !== link) focussedElement = link

    function toggleOpen() {
        const idx = $uniqueIDOpenList.indexOf(navigable.uniqueID)
        if (idx == -1) {
            // not  found
            $uniqueIDOpenList.push(navigable.uniqueID)
            $uniqueIDOpenList = $uniqueIDOpenList
        } else {
            // found, removing
            $uniqueIDOpenList = $uniqueIDOpenList.filter((s) => s != navigable.uniqueID)
        }
    }

    // Little workaround for what is to show what numbers there are
    $: linkName =
        (navigable.page.linkName[1].startsWith("What Is ") ||
        navigable.page.linkName[1].startsWith("What Am I")
            ? `(${211 + 10 * +navigable.page.linkName[0]}-${220 + 10 * +navigable.page.linkName[0]}) `
            : "") + navigable.page.linkName[1]
</script>

<div
    class="prefix"
    class:open
    class:focussed={focussed == navigable}
    class:openable={navigable.hasSubpages && !renderable}
>
    {navigable.page.linkName[0]}
</div>
<div
    bind:this={link}
    class="content"
    class:focussed={focussed == navigable}
    class:open
    class:openable={navigable.hasSubpages && !renderable}
>
    {#if isNavigableCategory(navigable.page) || (navigable.hasSubpages && !renderable)}
        <span
            tabindex="0"
            role="button"
            aria-controls={"expand-" + navigable.uniqueID}
            class="link"
            data-link-name={navigable.page.linkName[1]}
            class:active={open}
            aria-expanded={open}
            on:keydown={clickEnter}
            on:click={toggleOpen}>{linkName}</span
        >
    {:else}
        <a
            class="link"
            data-link-path={navigable.page.path}
            href={"/book/" + navigable.page.path}
            on:click={() => dispatch("navigate")}>{navigable.page.linkName[1]}</a
        >
    {/if}
</div>
{#if navigable.hasSubpages && navigable.subpages && open}
    {#if alreadyOpen}
        <div class="fullwidth">
            <div class="listgrid">
                {#each navigable.subpages as subnav}
                    <SubPageList
                        {focussed}
                        bind:focussedElement
                        {uniqueIDOpenList}
                        on:navigate={() => dispatch("navigate")}
                        navigable={subnav}
                    />
                {/each}
            </div>
        </div>
    {:else}
        <div
            class="fullwidth"
            id={"expand-" + navigable.uniqueID}
            transition:slide|global={{ duration: 300 }}
        >
            <div class="listgrid">
                {#each navigable.subpages as subnav}
                    <SubPageList
                        {focussed}
                        bind:focussedElement
                        {uniqueIDOpenList}
                        on:navigate={() => dispatch("navigate")}
                        navigable={subnav}
                    />
                {/each}
            </div>
        </div>
    {/if}
{/if}
